import {initSiteContext, siteContext, saveContext} from "./toolbox";

const logToOauth = ({login, password, refreshToken}, callback, reject) => {
  if(!siteContext().endpoint) initSiteContext();

  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');

  const body = !refreshToken ?
    {
      username: login,
      password: password,
      grantType:'password',
      scope:'read+write',
    } :
    {
      grantType: 'refresh_token',
      refreshToken: refreshToken,
    }

  fetch(`${siteContext().endpoint}/api/users/auth`,
    {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(body),
    }
  ).then(r => {
    if (r.ok && r.status === 200) {
      return r.json();
    }

    reject(r.status === 500);
  }).then(result => {
    if (!result) return;
    siteContext().accessToken = result.access_token;
    siteContext().refreshToken = result.refresh_token;
    saveContext();

    callback();
  }).catch(reject);
}

const ajaxCall = (url, params) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Authorization', `Bearer ${siteContext().accessToken}`);

  return fetch(`${siteContext().endpoint}${url}`, {
    ...params,
    headers: myHeaders,
  })
}

const authCall = (url, requestParams, callback, reject) => {
  if (!siteContext().endpoint) initSiteContext();

  if(!siteContext().accessToken) {
    window.location.replace('/login');
  }

  ajaxCall(url, requestParams).then(r => {
    if(!r.ok){
      if (r.status === 401) {
        return handleUnauthorized(url, requestParams);
      }
      reject();
    } else {
      return r.json()
    }
  }).then(result => {
    callback(result);
  })
}

const handleUnauthorized = (url, params) => {
  if(!siteContext().refreshToken) {
    window.location.replace('/login');
  }

  return logToOauth({refreshToken: siteContext().refreshToken},
    () => {
      return ajaxCall(url, params)
    },
    () => {window.location.replace('/login');})
}

export {
  logToOauth,
  authCall,
}